<section class="places-container">
  <div class="places-wrapper">
    <img src="assets/fondo2.png" class="bg-full-view" alt="Fondo Ceremonia" />

    <div class="places-overlay">
      
      <div class="section-box ceremony">
        <img src="assets/img/ANILLOS.png" class="icon" alt="Anillos">
        <h3 class="title-wedding">Ceremonia</h3>
        <p class="info-text">
          <b>Finca “El Secreto”</b> | Ruta 226 Km 21.5<br>
          Mar del Plata, Argentina
        </p>
        <span class="date-text">21 de Noviembre | 11:00h</span>
        <button class="btn-map" (click)="goToCeremony()">CÓMO LLEGAR</button>
      </div>

      <div class="section-box dress-code">
        <img src="../../../assets/img/MOÑO.png" class="icon" alt="Moño">
        <h3 class="title-wedding">Dress code</h3>
        <p class="dress-type">Elegante sport</p>
        <p class="dress-note">
          ¡No olvides traer calzado cómodo para caminar y bailar sobre el pasto!
        </p>
      </div>

    </div>
  </div>
</section>